<template>
  <tr class="table-cart" :id="'item-' + orderProduct.id">
    <td data-label="Produto">
      {{ orderProduct.title }}
      <br>
      <span class="small" v-if="orderProduct.quantities">
        {{ orderProduct.quantities }}
      </span>
    </td>
    <td data-label="Tipo">
      {{ productType }}
    </td>
    <td data-label="Período">
      <template v-if="orderProduct.days_to_expire">
        {{ orderProduct.days_to_expire }} DIAS
      </template>
      <span v-else>
        -
      </span>
    <td data-label="Quantidade">
      <div class="col-sm-offset-1 col-sm-10" v-if="orderProduct.is_license">
        <select class="form-control license_description" v-model="quantity" @input="alterItemTotal($event)">
          <option v-for="index in 20" :value="index">
            {{ index }}
          </option>
        </select>
      </div>

      <template v-else-if="productTypeId == 5 || productTypeId == 6">
        <div :class="batchClass">
          <select v-model="batchQuantity" class="form-control" @input="alterItemTotal($event)">
            <option v-for="(batch, index) in 10" :value="batch">{{ batch }}
              {{ batch == 1 ? 'lote' : 'lotes' }}
            </option>
            <option :selected="batchQuantity > 10" value="other">Outro</option>
          </select>
        </div>

        <div v-if="batchQuantity == 'other'" class="col-md-6 p-0">
          <input v-model="quantity" type="number" class="form-control only-numbers">
        </div>

      </template>

      <template v-else>
        {{quantity}}
      </template>
    </td>
    <td data-label="Valor Unitário">
      R$ {{ value }}
    </td>
    <td data-label="Desconto">
      R$ {{ discount }}
    </td>
    <td data-label="Valor Total">
      R$ {{ total }}
    </td>
    <td data-label="Remover do carrinho">
      <a href="#" @click="removeItem(orderProduct.id)">
        <i class="icon-remove s7-close-circle"></i>
      </a>
    </td>
  </tr>
</template>

<script>


  export default {
    name: 'table-item',

    props: {
      productKey: String,
      productType: String,
      orderProduct: Object,
      productTypeId: Number,
    },

    computed: {
      cart: {
        get() {
          return this.$store.getters['getCart'];
        },
        set(cart) {
          this.$store.commit('SET_CART', cart);
        }
      },

      batchClass() {
        return (this.batchQuantity === 'other') ? 'col-sm-6 p-0' : 'col-sm-offset-1 col-sm-10'
      }
    },

    data() {
      return {
        value: 0,
        discount: 0,
        total: 0,
        quantity: this.orderProduct.quantity,
        isAuthenticated: false,
        batchQuantity: (this.orderProduct.quantity <= 10) ? this.orderProduct.quantity : 'other',
      };
    },

    mounted() {
      this.$root.$emit('propagateType', this.productTypeId);
      this.value = this.orderProduct.value;
      this.discount = this.orderProduct.discount;
      this.total = this.orderProduct.formatted_total;
      this.isAuthenticated = !!window.User;
    },

    watch: {
      quantity: _.debounce(function (quantity) {
        if (this.isAuthenticated) {
          this.addToCart(quantity).then(response => {
            const product = response.product;
            this.updateProductValue(product);

            this.$root.$emit('updateTotals');

          });
        }
      }, 350),
      orderProduct(orderProduct) {
        this.updateProductValue(orderProduct);
      },

      batchQuantity(value) {
        if (value !== 'other') {
          this.quantity = +value;
        }
      },
    },

    methods: {
      alterItemTotal(event) {
        const quantity = event.target.value;
        if (quantity === 'other') {
          return;
        }

        if (!this.isAuthenticated) {
          const items = this.cart;
          const vm = this;
          const indexProduct = _.findIndex(items, function (item) {
            return item.product_id === vm.orderProduct.id;
          });
          if (indexProduct !== -1) {
            const oldProduct = items.splice(indexProduct, 1)[0];
            items.push({
              product_id: this.orderProduct.id,
              product_type_id: oldProduct.product_type_id || 1,
              quantity: quantity

            });
            this.cart = items;
            this.$root.$emit('updateTotals');
            this.updateProductLocalStorage(this.orderProduct.id, quantity);
          }
        } else {
          this.addToCart(quantity).then(response => {
            const product = response.product;
            this.updateProductValue(product);
          }).then(() => {
            if (this.productTypeId == 6 || this.productTypeId == 5) {
              this.$root.$emit('updateFreightFromItem');
            }
          });
        }
      },

      addToCart(quantity) {
        let $data = {
          id: this.orderProduct.product_id,
          quantity: +quantity,
          order_product_id: this.orderProduct.id,
        };
        return new Promise((resolve, reject) => {
          $.post('/ajax/store/cart', $data).done((data) => {
            resolve(data);
          }).fail((error) => {
            reject(error);
          });
        });
      },

      updateProductValue(product) {
        this.discount = product.formatted_discount;
        this.value = product.formatted_value;
        this.total = product.formatted_total;
      },

      updateProductLocalStorage(productId, quantity) {
        $.get('/ajax/store/product-local-storage/' + productId + '/' + quantity)
          .then((result) => {
            this.updateProductValue(result);
          }).catch();
      },

      removeItem(id) {
        if (!this.isAuthenticated) {
          let items = this.cart;
          const indexProduct = _.findIndex(items, function (item) {
            return item.product_id === id;
          });
          if (indexProduct !== -1) {
            items.splice(indexProduct, 1);
            this.cart = items;
            this.gritter('Sucesso!', 'Produto removido do carrinho.', 'info');
            updateNumberOfItems();
            this.$parent.$emit('removeItem', {id: id, key: this.productKey})
          }
        } else {
          axios.post('/ajax/store/remove/' + id).then((response) => {
            this.updateNumberOfItems();
            this.gritter('Sucesso!', response.data, 'info');

          }).then(() => {
            if (this.productTypeId == 6 || this.productTypeId == 5) {
              this.$root.$emit('updateFreightFromItem')
              this.$root.$emit('removeItemWithFreight');
            }
          }).then(() => this.$parent.$emit('removeItem', {id: id, key: this.productKey}))
            .catch((error) => {
            $('#item-' + id).show(200);
            this.gritter('Atenção!', 'Erro ao remover do carrinho.', 'danger');
          });
        }
      },

      updateNumberOfItems() {
        axios.post('/ajax/store/items').then((response) => {
          $('#cart-itens').html(response.data.numberOfItems);
        }).catch((error) => {
          if (error.status === 401) {
            this.gritter('Cadastre-se!', 'Economize com o TagSell Cartazista Eletrônico.', 'info');
          } else {
            this.gritter('Erro!', 'Não foi possível realizar a ação.', 'danger');
          }
        });
      },

      gritter(title, text, className) {
        $.gritter.add({
          title: title,
          time: 3000,
          text: text,
          class_name: 'color ' + className,
        });
      },
    },

  };
</script>

<style scoped>
  .table-cart td {
    vertical-align: middle;
    padding-top: 8px;
  }

  .icon-remove {
    padding-right: 5px;
  }

  .license_description {
    margin-bottom: 0;
    padding-left: 23px;
  }

  @media screen and (max-width: 600px) {
    .license_description {
      max-width: 31%;
      margin-left: 73%;
    }
  }

  @media screen and (min-width: 768px) {
    .license_description {
      max-width: 70%;
      margin-left: 15%;
    }
  }
</style>





// WEBPACK FOOTER //
// resources/assets/js/store/components/TableItem.vue